export const fieldTranslations = {
  // General information
  name: "Nom",
  currency: "Devise",
  isin: "ISIN",
  code: "Code",
  company_name: "Société de gestion",
  asset_class_1: "Classe d'actif principale",
  asset_class_2: "Classe d'actifs",

  n1_issuer_name: "Emetteur",

  // Technical information
  strategy_id: "ID de la stratégie",

  // Other loan fields
  loan_amount_granted: "Montant du prêt accordé",
  loan_with_collateral: "Prêt consenti avec nantissement",
  concentrated_asset: "Actif concentré du client",

  // Technical fields
  created_at: "Créé le",
  updated_at: "Mis à jour le",
};

export default fieldTranslations;
